// extracted by mini-css-extract-plugin
export default {"ourApproach":"OurApproach_ourApproach__XyHuV","ourApproachTitle":"OurApproach_ourApproachTitle__DG66-","ourApproachContainer":"OurApproach_ourApproachContainer__JOCAE"};